import { EnvironmentProviders, ErrorHandler, makeEnvironmentProviders } from '@angular/core';

import { GlobalErrorHandlerService } from '@core/shared/util';
import { provideAppInsightsDataAccess } from '@mp/shared/app-insights/data-access';

export function provideAppInsightsFeature(): EnvironmentProviders[] {
  return [
    provideAppInsightsDataAccess(),
    makeEnvironmentProviders([
      {
        provide: GlobalErrorHandlerService,
        useFactory: (errorHandler: ErrorHandler) => {
          return errorHandler instanceof GlobalErrorHandlerService ? errorHandler : null;
        },
        deps: [ErrorHandler],
      },
    ]),
  ];
}
